<template>
  <PopupAlert
    v-show="alert.show"

    :title="alert.title"

    :btn_close="alert.btn_close"

    :show_btn="alert.show_btn"
    :btn_cancel="alert.btn_cancel"
    :btn_cancel_title="alert.btn_cancel_title"
    
    :btn_submit="alert.btn_submit"
    :btn_submit_title="alert.btn_submit_title"

    @close="close"
  >
    {{alert.content}}
  </PopupAlert>
</template>
<script>
import { mapState } from 'vuex';
import PopupAlert from './PopupAlert.vue';
export default {
  components: {
    PopupAlert,
  },
  computed: {
    ...mapState({
      alert: state => state.alert, 
    })
  },
  methods: {
    close(submit) {
      
      if(submit && this.alert.submit) 
        this.alert.submit();
      
      this.$store.commit('CLEAR_ALERT');
    }
  },
}
</script>

<style lang="css" scoped></style>